module.exports = __webpack_public_path__ + "static/media/Artboard5.43219161.png";